export const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: state.isDisabled ? " whitesmoke" : "white",
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: " #eb0058",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#FFF",
    fontWeight: "bold",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "white",
    ":hover": {
      backgroundColor: "#ff0d6c",
      color: "white",
    },
  }),
};

export const optionsChartBarVendas = {
  maintainAspectRatio: false,
  responsive: false,
  aspectRatio: 1,
  title: {
    display: true,
    padding: 0,
    text: "Valor Total de Vendas",
    fontColor: "#FC68A2",
    fontSize: 20,
    align: "left",
  },
  legend: {
    position: "bottom",
    align: "start",
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  scales: {
    yAxes: [
      {
        id: "y-axis-1",
        position: "left",
        ticks: {
          beginAtZero: true,
        },
      },
      {
        id: "y-axis-2",
        position: "right",
        gridLines: {
          drawOnChartArea: false,
        },
        ticks: {
          beginAtZero: true,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          padding: 25,
        },
      },
    ],
  },
  tooltips: {
    mode: "index",
    intersect: false,
    callbacks: {
      label: function (tooltipItem, data) {
        let label = data.datasets[tooltipItem.datasetIndex].label || '';
        if (label) {
          label += ': ';
        }
        if (data.datasets[tooltipItem.datasetIndex].yAxisID === "y-axis-1") {
          label += parseFloat(tooltipItem.yLabel || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        } else {
          label += parseFloat(tooltipItem.yLabel || 0).toLocaleString('pt-BR');
        }
        return label;
      }
    }
  },
  plugins: {
    datalabels: {
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};

export function calculateWidth(dados) {
  console.log({ dados });

  const x = dados.labels;
  let length = x ? x.length : 0;
  if (length <= 13) {

    return 1000;
  }

  return length * 80;
}
